import { render, staticRenderFns } from "./GraficoRespondids.vue?vue&type=template&id=0c308cc4&scoped=true&"
import script from "./GraficoRespondids.vue?vue&type=script&lang=js&"
export * from "./GraficoRespondids.vue?vue&type=script&lang=js&"
import style0 from "./GraficoRespondids.vue?vue&type=style&index=0&id=0c308cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c308cc4",
  null
  
)

export default component.exports